import { ResetPasswordScreen } from "@/app/modules/User";

export const ResetPassword = () => {
  return <ResetPasswordScreen />;
};
